// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchInput_searchWrapper__EdO15","searchIcon":"SearchInput_searchIcon__RMBae","searchInput":"SearchInput_searchInput__hqyxS"};